var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"video",class:{ mirrored: _vm.mirrored },attrs:{"autoplay":"","playsinline":""},domProps:{"muted":_vm.muted},on:{"playing":_vm.onPlaying,"pause":_vm.onPause,"click":function($event){return _vm.onClick()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }